import React, { useState, useEffect } from "react";
import { Button } from "bootstrap-4-react/lib/components";
import { useLocation, useNavigate } from "react-router-dom";
import Table from "react-bootstrap/Table";
import FilterIncoming from "./filterIncoming";
import { useDispatch, useSelector } from "react-redux";
import {
  downloadPackagesCsvReport,
  getFilterPackagesList,
  getPackagetypeList,
  getSourceListList,
  packageBackDetails,
} from "../../store/actions/incoming";
import BatchPagination from "../batch/BatchPagination";
import { featureSubmodulePermission, numOfPage, packages, permssionView, permssionEdit, returnsManagement, permssionCreate } from "../../constant";
import moment from "moment";
import LoaderSpinner from "../common/Loader";
import ViewImage from "../common/ViewImage";
import _, { filter, set } from "lodash";
import { checkPermission, renderTableRow } from "../../config/utils";
import ActionItems from "../common/showActions";
import { toast } from "react-toastify";
import PropTypes from "prop-types";
import PackageListPopover from "../common/PackagesPopover";

const PackageList = (props) => {
  const navigate = useNavigate();
  const UserValue = useSelector((state) => state.auth.user);
  const packagesList = useSelector(
    (state) => state.IncomingReducer.packagesList
  );
  const packagesListPageInfo = useSelector(
    (state) => state.IncomingReducer.packagesListPageInfo
  );
  const packagesListStatus = useSelector(
    (state) => state.IncomingReducer.packagesListStatus
  );
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [productsPopover, setProductsPopover] = useState({});
  const { packageBackDetailsObj } = useSelector((state) => state.IncomingReducer);
  const dispatch = useDispatch();
  const location = useLocation();
  const trackingNumber = location?.state?.trackingNumber || '';
  const [loader, setLoader] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedRecord, setSelectedRecord] = useState([]);
  const [showHideImageModal, setShowHideImageModal] = useState(false);
  const [sellerList, setSellerList] = useState([]);
  const [allSellers, setAllSellers] = useState([]);
  const [dateSelected, setDateSelected] = useState(null);

  useEffect(() => {
    if (packagesList.length) {
      setTotalPages(
        Math.ceil(packagesListPageInfo?.TotalRecords / filterValue.pageSize)
      );
    }
  }, [packagesList]);

  let dataLoad = {
    pageIndex: 1,
    pageSize: 30,
    sortColumn: "",
    date: location?.state?.date,
    searchKeywords: "",
    packageTypes: [],
    sources: [],
    sellerIdList: [],
    companyIdList: [],
    carriers: [],
    trackingNumber: trackingNumber,
    showFilter: true,
    searchTxt: '',
    sortOrder: 'DESCENDING',
    showSearch: true,
    companySellerId: 0,
    isSuperAdmin: UserValue?.Value?.isSuperAdmin,
    billingStatusList: [],
  }

  const [filterValue, setFilterValue] = useState({});

  useEffect(() => {
    if (!_.isEmpty(packageBackDetailsObj)) {
      setFilterValue({ ...filterValue, ...packageBackDetailsObj });
    } else {
      setFilterValue({ ...dataLoad });
    }
  }, []);

  useEffect(() => {
    if (location?.state?.date && moment(location?.state?.date).isValid()) {
      setDateSelected(location?.state?.date);
    }
  }, [location?.state?.date])

  useEffect(() => {
    if (location?.state?.date && moment(location?.state?.date).isValid()) {
      if (!_.isEmpty(filterValue)) {
        fetchFilterPackageList();
      }
    } else {
      navigate("/incoming-packages");
    }
  }, [filterValue.pageIndex, filterValue.pageSize, filterValue.sortColumn, filterValue.sortOrder, location?.state?.date]);

  useEffect(() => {
    if (packagesListStatus === "pending") {
      setLoader(true);
    } else {
      setLoader(false);
    }
  }, [packagesListStatus]);

  const fetchFilterPackageList = () => {
    let data = {
      ...filterValue,
      pageIndex: filterValue.pageIndex,
      pageSize: filterValue.pageSize,
      sortColumn: filterValue.sortColumn,
      sortOrder: filterValue.sortOrder,
      date: !filterValue.fromDate &&
        !filterValue.toDate
        ? location?.state?.date
        : undefined,
      searchKeywords: filterValue.searchTxt.trim(),
      searchTxt: filterValue.searchTxt.trim(),
      isSuperAdmin: UserValue?.Value?.isSuperAdmin,
      trackingNumber: trackingNumber || '',
      sources: _.map(filterValue.sources, "id"),
      packageTypes: _.map(filterValue.packageTypes, "id"),
      sellerIdList: _.map(filterValue.companySellerId, "id"),
      companyIdList: _.map(filterValue.companyIdList, "Id"),
      carriers: _.map(filterValue.carriers, "id"),
      billingStatusList: Array.isArray(filterValue.billingStatusList) ? _.map(filterValue.billingStatusList, item => item?.value || item) : [],
    };
    (filterValue.filterApplied || data.searchKeywords) &&  (data.date = null);
    data.trackingNumber && (data.date = null);
    data.companySellerId = 0;
    dispatch(getFilterPackagesList(data));
  };

  useEffect(() => {
    window.scroll(0, 0);
    dispatch(getSourceListList());
    dispatch(getPackagetypeList());
  }, []);

  const handleEditRow = (item) => {
    dispatch(packageBackDetails(filterValue));
    navigate(
      `/incoming-packages/fd-${location?.state?.date}-3pl/${item.internalId}`,
      {
        state: {
          view: false,
          boxId: item.internalId,
          date: location?.state?.date,
        },
      }
    );
  };
  
  const handleViewRow = (item) => {
    dispatch(packageBackDetails(filterValue));
    navigate(`/incoming-packages/fd-${location?.state?.date}-3pl/${item.internalId}`, {
      state: {
        view: true,
        boxId: item.internalId,
        date: location?.state?.date,
      },
    });
  };

  const handleSortingCoulmn = (event, sortColumn) => {
    event.preventDefault();
    let newSortOrder = filterValue.sortOrder === "ASCENDING" ? "DESCENDING" : "ASCENDING";
    setFilterValue({
      ...filterValue,
      sortColumn: sortColumn,
      sortOrder: newSortOrder,
      pageIndex: 1,
    });
  };

  const handleSearchFilter = (e, type) => {
    if (type === "clear") {
      handleResetSearch();
      return;
    }
    if (filterValue.pageIndex !== 1) {
      setFilterValue({ ...filterValue, pageIndex: 1, filterApplied: true });
    } else {
      setFilterValue({ ...filterValue, filterApplied: true });
      fetchFilterPackageList();
    }
  };

  const handleResetSearch = () => {
    let data = {
      ...dataLoad,
      pageSize: filterValue.pageSize
    };
    setFilterValue({ ...data });
    dispatch(getFilterPackagesList(data));
  }

  const handleEnterClick = (e) => {
    if (e.key === "Enter") {
      handleSearchFilter(e, "enter");
    }
  };

  const handleBlur = (e) => {
    const { value } = e.target;
    setFilterValue({ ...filterValue, searchTxt: value.trim() });
  };

  const handleReset = () => {
    if (filterValue.pageIndex !== 1) {
      setFilterValue({ ...dataLoad, pageSize: filterValue.pageSize, pageIndex: 1, filterApplied: false  });
    } else {
      setFilterValue({ ...dataLoad, pageSize: filterValue.pageSize, filterApplied: false });
      let data = JSON.parse(JSON.stringify(dataLoad));
      data.pageSize = filterValue.pageSize
      dispatch(getFilterPackagesList(data));
      setSellerList(allSellers);
    }
  }

  const handleBackNavigation = () => {
    const date = location?.state?.date
    if (location?.state?.trackingNumber) {
      navigate(`/incoming-products/product-details`, {
        state: {
          date,
        },
      })
    } else {
      navigate("/incoming-packages");
      dispatch(packageBackDetails({}));
    }
  };

  const handleDownloadCsv = async () => {
    let data = {
      ...filterValue,
      pageIndex: filterValue.pageIndex,
      pageSize: filterValue.pageSize,
      sortColumn: filterValue.sortColumn,
      sortOrder: filterValue.sortOrder,
      date: (filterValue.fromDate || filterValue.toDate) ? '' : location?.state?.date,
      searchKeywords: filterValue.searchTxt,
      isSuperAdmin: UserValue?.Value?.isSuperAdmin,
      trackingNumber: trackingNumber || '',
      sources: _.map(filterValue.sources, "id"),
      packageTypes: _.map(filterValue.packageTypes, "id"),
      sellerIdList: _.map(filterValue.companySellerId, "id"),
      companyIdList: _.map(filterValue.companyIdList, "Id"),
      carriers: _.map(filterValue.carriers, "id"),
      companySellerId: 0,
    };
    data.trackingNumber && (data.date = null);
    setLoader(true);
    let downloadRes = await downloadPackagesCsvReport(data);
    if (downloadRes?.data?.Status === 200) {
      toast.success(downloadRes?.data?.Entity);
    } else {
      toast.error(downloadRes?.data?.Entity);
    }
    setLoader(false);
  };

  const handleSortingClass = (columnName, isArrow = false) => {
    if (isArrow) {
      return filterValue.sortColumn === columnName && filterValue.sortOrder === "ASCENDING"
        ? "fa fa-arrow-up"
        : "fa fa-arrow-down";
    }
    return filterValue.sortColumn === columnName ? "active" : "sortColumn";
  };

  const handleCreate = (e) => {
    navigate(`/incoming-packages/create-packages/${0}`, {
      state: { view: false, isCreated: true },
    });
  };

  return (
    <main>
      <div className="main__container">
        <div className="main__tile_heading cus-btn-include-sec">
          <div>
            Return Packages Detail View
            <h5 className="mt-2">
              {!filterValue.filterApplied && moment(new Date(dateSelected)).format("MM-DD-YYYY")}
            </h5>
          </div>
          <div className="top_right_button_container">
            <button
              className="btn cus-seconday-bg-btn top-btn m2"
              onClick={() => handleDownloadCsv()}
              disabled={loader || !packagesList?.length}
            >
              Download CSV
            </button>
            {checkPermission(returnsManagement, packages, permssionCreate, featureSubmodulePermission, props.employeePermissions) && (
              <Button
                className="cus-seconday-bg-btn top-btn"
                onClick={() => handleCreate()}
              >
                <i className="fa fa-plus" aria-hidden="true"></i> Create Package
              </Button>
            )}
            {/* <button className="btn cus-seconday-bg-btn top-btn m2" onClick={() => handleFilterToggle('showFilter', !filterValue.showFilter)}>Filter</button> */}
            <Button
              className="cus-primary-transparent-btn top-btn"
              onClick={() => { handleBackNavigation() }}
            >
              Back
            </Button>
          </div>
        </div>
        {loader && (<div className="full-screen-spinner-overlay"><LoaderSpinner /></div>)}
        <div
          className={
            filterValue.showSearch
              ? "filterContainer show searchBox mb-2"
              : "filterContainer searchBox"
          }
        >
          <div className="searchInputBox">
            <input
              value={filterValue.searchTxt}
              onBlur={handleBlur}
              onKeyDown={handleEnterClick}  
              onChange={(e) => setFilterValue({ ...filterValue, searchTxt: e.target.value })}
              className="form-control"
              placeholder="Search Company, Seller, Seller Code, Tracking Number, Package Type, Carrier, STE Code or Source"
            />
          </div>
          <button
            className="btn cus-seconday-bg-btn ml-2 searchBtn"
            onClick={(e) => handleSearchFilter(e, "search")}
          >
            <i className="fa fa-search" aria-hidden="true"></i> Search
          </button>
          <button
            disabled={!filterValue.searchTxt}
            className="btn cus-primary-transparent-btn ml-2 clearbtn"
            onClick={(e) => handleSearchFilter(e, "clear")}
          >
            Clear Search
          </button>
        </div>
        {filterValue.showFilter && (
          <FilterIncoming
            filterValue={filterValue}
            setFilterValue={setFilterValue}
            getFilterPackagesList={getFilterPackagesList}
            dataLoad={dataLoad}
            handleReset={handleReset}
            sellerList={sellerList}
            setSellerList={setSellerList}
            allSellers={allSellers}
            setAllSellers={setAllSellers}
          />
        )}

        <div className="main_content cus-page-content-sec">
          <div className="main_content_table_history">
            <div className="incomingTbl tableFixHead">
              <Table className="table table-height cus-left-right-col-layout">
                <thead>
                  <th>Thumbnail</th>
                  {UserValue?.Value?.roleName !== 'Seller' && (
                    <th width="20%" className="companySellerCol">
                      <button
                        className={
                          filterValue.sortColumn === "companySellerName"
                            ? "active sortBtn"
                            : "sortColumn sortBtn"
                        }
                        onClick={(e) => handleSortingCoulmn(e, "companySellerName")}
                      >
                        Company / Seller Name {" "}
                        <i
                          className={handleSortingClass("companySellerName", true)}
                          aria-hidden="true"
                        ></i>
                      </button>
                    </th>
                  )}
                  <th>Products</th>
                  <th width="15%">
                    <button
                      className={
                        filterValue.sortColumn === "trackingNumber"
                          ? "active sortBtn"
                          : "sortColumn sortBtn"
                      }
                      onClick={(e) => handleSortingCoulmn(e, "trackingNumber")}
                    >
                      Tracking Number  {" "}
                      <i
                        className={
                          handleSortingClass("trackingNumber", true)
                        }
                        aria-hidden="true"
                      ></i>
                    </button>
                  </th>
                  <th width="15%">
                    Billing Status
                  </th>
                  <th width="15%">
                    Invoice Date
                  </th>
                  <th width="15%">
                    Received Date
                  </th>
                  <th>
                    <button
                      className={
                        filterValue.sortColumn === "carrierName"
                          ? "active carrierName sortBtn"
                          : "sortColumn carrierName sortBtn"
                      }
                      onClick={(e) => handleSortingCoulmn(e, "carrierName")}
                    >
                      Carrier {" "}
                      <i
                        className={
                          handleSortingClass("carrierName", true)
                        }
                        aria-hidden="true"
                      ></i>
                    </button>
                  </th>

                  <th>
                    <button
                      className={
                        filterValue.sortColumn === "packageType"
                          ? "active sortBtn"
                          : "sortColumn sortBtn"
                      }
                      onClick={(e) => handleSortingCoulmn(e, "packageType")}
                    >
                      Package Type {" "}
                      <i
                        className={
                          handleSortingClass("packageType", true)
                        }
                        aria-hidden="true"
                      ></i>
                    </button>
                  </th>
                  <th>
                    <button
                      className={
                        filterValue.sortColumn === "source" ? "active sortBtn" : "sortColumn sortBtn"
                      }
                      onClick={(e) => handleSortingCoulmn(e, "source")}
                    >
                      Source {" "}
                      <i
                        className={
                          handleSortingClass("source", true)
                        }
                        aria-hidden="true"
                      ></i>
                    </button>
                  </th>
                  <th width="15%">Action</th>
                </thead>
                <tbody>
                  {packagesList && packagesList.length > 0 && (
                    <>
                      {packagesList.map((item, index) => (
                        <tr key={item.internalId}>
                          <td>
                            {item.thumbnailUrl ? (
                              <button
                                className="thumbImg sortBtn"
                                onClick={() => {
                                  setSelectedRecord(item);
                                  setShowHideImageModal(!showHideImageModal);
                                }}
                              >
                                <img src={item.thumbnailUrl} alt="" />
                              </button>
                            ) : (
                              <></>
                            )}
                          </td>
                          {UserValue?.Value?.roleName !== 'Seller' && (
                            <td className="companySellerCol">{item.companySellerName}</td>
                          )}
                          <td>
                            <button
                              className="seller-modal sortBtn tableLink"
                              key={item.internalId}
                              onClick={(e) => {
                                e.preventDefault();
                                setProductsPopover(item);
                                setAnchorEl(e.currentTarget);
                              }}
                            >
                              {item?.products}
                            </button>
                          </td>
                          <td>
                            {item.trackingUrl ? (
                              <a
                                rel="noreferrer"
                                href={item.trackingUrl}
                                target="_blank"
                              >
                                {item.trackingNumber}
                              </a>
                            ) : (
                              <>{item.trackingNumber}</>
                            )}
                          </td>
                          <td>{item.billingStatus}</td>
                            
                          <td>{item.invoiceDate ? moment(item.invoiceDate).format("MM-DD-YYYY") : "-"}</td>
                          <td>{item.receivedDate ? moment(item.receivedDate).format("MM-DD-YYYY") : "-"}</td>

                          <td>{item.carrierName}</td>
                          <td>{item.packageType}</td>
                          <td>{item.source}</td>
                          <td>
                            {checkPermission(returnsManagement, packages, permssionView, featureSubmodulePermission, props.employeePermissions) && (
                              <ActionItems
                                type={"View"}
                                item={item}
                                handleAction={() =>
                                  handleViewRow(item)
                                }
                              />
                            )}
                            {checkPermission(returnsManagement, packages, permssionEdit, featureSubmodulePermission, props.employeePermissions) && (
                              UserValue?.Value?.roleName !== "Seller" &&
                              <ActionItems
                                type={"Edit"}
                                item={item}
                                handleAction={() =>
                                  handleEditRow(item)
                                }
                              />
                            )}
                          </td>
                        </tr>
                      ))}
                    </>
                  )}
                  {packagesListStatus === "success" && packagesList.length === 0 && (
                    <>{renderTableRow(11, 'No Record Found')}</>
                  )}
                  {packagesListStatus !== "success" && (renderTableRow(11, 'Loading...'))}
                </tbody>
              </Table>
            </div>
          </div>
          <BatchPagination
            gridData={packagesList || []}
            totalVisualRecords={packagesList?.length}
            numberOfPage={filterValue.pageSize}
            numOfPage={numOfPage}
            loader={loader}
            currentPage={filterValue.pageIndex}
            totalPages={totalPages || 0}
            totalRecords={packagesListPageInfo?.TotalRecords}
            setCurrentPage={(value) => setFilterValue({ ...filterValue, pageIndex: value })}
            setNumberOfPage={(value) => setFilterValue({ ...filterValue, pageSize: value, pageIndex: 1 })}
          />
          <ViewImage
            selectedRecord={selectedRecord}
            setShowHideImageModal={setShowHideImageModal}
            showHideImageModal={showHideImageModal}
          />

          {anchorEl && (
            <PackageListPopover 
              anchorEl={anchorEl}
              open={open}
              onClose={() => setAnchorEl(null)}
              productsPopover={productsPopover}
            />
          )}
        </div>
      </div>
    </main>
  );
};

PackageList.propTypes = {
  employeePermissions: PropTypes.array,
}

export default PackageList;
